import { combineReducers } from 'redux';
import { insurerReducer } from './Insurer';
import { provinceReducer } from './Province';
import { orderTemplateReducer } from './OrderTemplate';
import { companyReducer } from './Company';
import { healthPlanReducer } from './HealthPlan';
import { userReducer } from './User';
import { benefitTemplateReducer } from './BenefitTemplate';
import { insurancePolicyUserReducer } from './InsurancePolicyUser';
import { ingestionReducer } from './Ingestion';
import { documentReducer } from './Document';
import { collaborationReducer } from './Collaboration';
import { insurerTeamReducer } from './InsurerTeam';
import { insuranceTemplateReducer } from './InsuranceTemplate';
import { actionRequestReducer } from './ActionRequest';

export default combineReducers({
  insurerReducer,
  provinceReducer,
  orderTemplateReducer,
  companyReducer,
  healthPlanReducer,
  userReducer,
  benefitTemplateReducer,
  insurancePolicyUserReducer,
  ingestionReducer,
  documentReducer,
  collaborationReducer,
  insurerTeamReducer,
  insuranceTemplateReducer,
  actionRequestReducer,
});
